import React, { FC, useState } from "react";
import CommonLayout from "./CommonLayout";
import Textarea from "shared/Textarea/Textarea";
import Input from "shared/Input/Input";

export interface PageAddListing7Props {
  formik: any;
}

const PageAddListing7: FC<PageAddListing7Props
> = ({ formik }) => {
  const handleInputChange = (val: any) => {
    formik.setFieldValue("propertyRules", val.target.value);
  };
const rulesInString = Array.isArray(formik.values.propertyRules)
  ? formik.values.propertyRules.join(",") 
  : formik.values.propertyRules || ""; 
  return (
    <CommonLayout
      index="07"
      backtHref="/add-listing-6"
      nextHref="/add-listing-8"
    >
      <>
        <div>
          <h2 className="text-2xl font-semibold">Property Rules</h2>
        </div>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">
            Note: Separate multiple rules with a comma (e.g., No smoking, No pets, Check-in after 2PM)
        </span>
        <Textarea
          value={rulesInString ? rulesInString : formik.values.propertyRules}
          handleChange={handleInputChange}
          placeholder="..."
          rows={14}
        />
        <Input
          className="!sm:w-full md:w-4/6 lg:w-full text-neutral-900"
          placeholder="Airbnb link if available"
          {...formik.getFieldProps("airbnb_link")}
        />
         {formik.errors && formik.errors.airbnb_link && (
          <span className="text-red-500 text-sm">
            {formik.errors.airbnb_link}
          </span>
        )}
      </>
    </CommonLayout>
  );
};

export default PageAddListing7;
